import { Modal } from '@mui/material';
import { MouseEvent, memo } from 'react';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  open: boolean;
  title: string;
  body?: string;
  actionLabel: string;
  dismissLabel?: string;
  // 'danger' for destructive confirmations, 'primary' for the rest.
  tone?: 'danger' | 'primary';
  onConfirm: () => void;
  onDismiss: () => void;
};

export const ActionConfirmModal = memo(
  ({
    open,
    title,
    body,
    actionLabel,
    dismissLabel = 'Cancel',
    tone = 'danger',
    onConfirm,
    onDismiss,
  }: Props) => (
    <Modal open={open} onClose={onDismiss}>
      <div
        onClick={(event: MouseEvent<HTMLDivElement>) => event.stopPropagation()}
        className="absolute left-1/2 top-1/2 w-[326px] -translate-x-1/2 -translate-y-1/2 rounded-[10px] bg-white shadow-[0px_0px_1px_#EAECF0,0px_32px_64px_-12px_rgba(29,41,57,0.08)] md:w-[520px]"
      >
        <div className="flex items-center justify-between p-8 pb-4">
          <h4 className="text-2xl font-bold">{title}</h4>
          <button type="button" aria-label="Close" onClick={onDismiss}>
            <FontAwesomeIcon icon={faXmark} className="text-xl" />
          </button>
        </div>
        {body && (
          <div className="flex px-8">
            <p className="text-lg">{body}</p>
          </div>
        )}
        <div className="flex justify-end gap-6 p-8">
          <button
            type="button"
            onClick={onDismiss}
            className="text-lg font-medium text-[#131313]"
          >
            {dismissLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`rounded-[10px] px-5 py-2.5 text-lg font-medium text-white ${
              tone === 'danger' ? 'bg-[#DA0000]' : 'bg-[#131313]'
            }`}
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </Modal>
  ),
);

ActionConfirmModal.displayName = 'ActionConfirmModal';
